export const CARD_VISIBILITY_OBSERVATION = 'card_visibility_observation';
